import { gql, useMutation } from '@apollo/client'
import { useCallback } from 'react'

export const EDIT_PROFILE_PHONE_FOR_SIGNUP_MUTATION = gql`
  mutation EditProfilePhoneForSignup($input: EditProfilePhoneInput!) {
    editProfilePhone(input: $input) {
      profile {
        id
      }
    }
  }
`

type EditProfilePhoneForSignupMutation = {
  editProfilePhone: { profile: { id: string } | null } | null
}

type EditProfilePhoneForSignupMutationVariables = {
  input: {
    area: string
    phone: string
    action: string
    origin: string
    sendNumberRegistrationWhatsappMessage: boolean
    requestWhatsAppOptIn: boolean
  }
}

export function useEditProfilePhoneForSignup() {
  const [mutate, { loading }] = useMutation<
    EditProfilePhoneForSignupMutation,
    EditProfilePhoneForSignupMutationVariables
  >(EDIT_PROFILE_PHONE_FOR_SIGNUP_MUTATION)

  const execute = useCallback(
    async (digits: string): Promise<string | null> => {
      const area = digits.slice(0, 2)
      const phone = digits.slice(2)
      try {
        await mutate({
          variables: {
            input: {
              area,
              phone,
              action: 'ADD',
              origin: 'signup-phone-step',
              sendNumberRegistrationWhatsappMessage: false,
              // Trigger the WhatsApp double opt-in invite for this phone; the resolver
              // forwards `origin` as the opt-in source.
              requestWhatsAppOptIn: true,
            },
          },
        })
        return null
      } catch (err) {
        return err instanceof Error ? err.message : 'Erro ao salvar telefone'
      }
    },
    [mutate]
  )

  return { execute, loading }
}
